import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  message: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: ({ id }) => id && 8
  },
  icon: {
    marginRight: theme.spacing(2)
  },
  content: {
    marginLeft: ({ id }) => id && 40
  }
}));

const ToastMessage = ({ content, Icon, errorId }) => {
  const classes = useStyles({ id: errorId });
  const { t } = useTranslation(['actions']);

  return (
    <>
      <div className={classes.message}>
        <Icon className={classes.icon} />
        {errorId ? (
          <div>
            <span>{t('toasts.error id')}: </span>
            <strong>{errorId}</strong>
          </div>
        ) : (
          <div className={classes.content}>{t(content)}</div>
        )}
      </div>
      {errorId && <div className={classes.content}>{content}</div>}
    </>
  );
};

ToastMessage.propTypes = {
  Icon: PropTypes.object,
  content: PropTypes.string,
  errorId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default ToastMessage;
